__turbopack_context__.v({
  "items": "styles-module__GJ6nta__items",
  "message": "styles-module__GJ6nta__message",
  "tabPanel": "styles-module__GJ6nta__tabPanel",
});
